import { render, staticRenderFns } from "./PieChartTable.vue?vue&type=template&id=487a5a7f&"
import script from "./PieChartTable.vue?vue&type=script&lang=js&"
export * from "./PieChartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports